const fr = {
  "runtime.invalid_json": (position: string) => `Erreur dans la structure du JSON ${position}`,
};

export default fr;
